// removed by extract-text-webpack-plugin
module.exports = {"ResgisterBtnCell":"ResgisterBtnCell","ResgisterBtnModal":"ResgisterBtnModal","form-group":"form-group","form-control":"form-control","ButtonSection":"ButtonSection","SubmitButton":"SubmitButton","CancelButton":"CancelButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/RightInfomation/RegisterBtnCell/styles.scss
// module id = 2276
// module chunks = 10